class LazyVideo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.video = window.BAO.Utils.getElement('video', { context: this })

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      threshold: 0,
    })
    // We need to observe the video element as the host element has display: contents on it. IntersectionObserver won't work on an element that is set to display: contents
    this.observer.observe(this.video)

    this.resizeObserver = new ResizeObserver(() => {
      this.updateAudioToggleVisibility(this.isVideoVisible())
    })

    this.resizeObserver.observe(this.video)
  }

  createAudioToggle () {
    const audioToggle = this.dataset.audioToggle
    if (audioToggle !== 'true') return
    if (this._audioButton) return

    /* Button */
    const button = document.createElement('button')
    button.classList.add('mda-Control')

    /* Content */
    button.setAttribute('aria-label', 'Toggle audio')

    this.appendChild(button)

    button.addEventListener('click', () => this.toggleAudio(button))
    this._audioButton = button
  }

  toggleAudio (button) {
    const isPressed = button.getAttribute('aria-pressed') === 'true'
    button.setAttribute('aria-pressed', String(!isPressed))
    this.video.muted = !this.video.muted
  }

  isVideoVisible () {
    const style = getComputedStyle(this.video)

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      this.video.offsetWidth > 0 &&
      this.video.offsetHeight > 0
    )
  }

  updateAudioToggleVisibility (isVisible) {
    if (!this._audioButton) return

    this._audioButton.setAttribute('aria-hidden', String(!isVisible))
    this._audioButton.style.display = isVisible ? '' : 'none'
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    if (this.video.dataset?.poster) {
      this.video.setAttribute('poster', this.video.dataset.poster)
    }

    for (const source in this.video.children) {
      const videoSource = this.video.children[source]

      if (
        typeof videoSource.tagName === 'string' &&
        videoSource.tagName === 'SOURCE'
      ) {
        videoSource.src = videoSource.dataset.src
      }
    }

    this.video.load()
    observer.unobserve(this.video)

    this.setAttribute('loaded', '')
    this.createAudioToggle()

    if (
      window.BAO.MediaBreakpoints.isSm ||
      this.video.hasAttribute('autoplay') === false
    ) {
      return
    }

    if (this.video.paused) {
      document.addEventListener('touchstart', () => {
        if (this.video.paused) {
          this.video.play()
        }
      })
    }
  }
}

if (!customElements.get('lazy-video')) {
  customElements.define('lazy-video', LazyVideo)
}
